import { isDemoBuild } from "./siteConfig.js";

/** Macon County NC tax assessor GIS — NMR lots are in Topton, Macon County. */
export const MACON_PARCEL_GIS = {
  county: "Macon County",
  state: "NC",
  arcgisLayerUrl:
    "https://gis.maconnc.org/arcgis/rest/services/TemplateSite/TaxParcels/MapServer/0",
  mapViewerUrl: "https://gis2.maconnc.org/lightmap/Maps/default.htm",
  parcelRecordUrl: "https://gis2.maconnc.org/lightmap/SearchFind.aspx",
  parcelSearchUrl: "https://gis2.maconnc.org/lightmap/searchfind.aspx",
  downloadsUrl: "https://gis2.maconnc.org/lightmap/downloads.aspx",
  dataSourceNote: "Macon County Tax GIS",
};

/** Macon lightmap expects ?pid= for maps and ?ParcelID= for tax record search. */
export function resolveAssessorLinks(parcelGis) {
  const pin = parcelGis?.pin;
  if (!pin || String(pin).startsWith("DEMO-")) {
    if (!isDemoBuild) return null;
    return {
      countyMap: MACON_PARCEL_GIS.mapViewerUrl,
      parcelRecord: MACON_PARCEL_GIS.parcelSearchUrl,
    };
  }

  const pid = encodeURIComponent(String(pin).trim());
  return {
    countyMap: `${MACON_PARCEL_GIS.mapViewerUrl}?pid=${pid}`,
    parcelRecord: `${MACON_PARCEL_GIS.parcelRecordUrl}?ParcelID=${pid}`,
  };
}

export function formatParcelSummary(parcelGis) {
  if (!parcelGis) return null;
  const parts = [];
  if (parcelGis.pin) parts.push(`PIN ${parcelGis.pin}`);
  if (typeof parcelGis.acreage === "number") parts.push(`${parcelGis.acreage.toFixed(2)} ac`);
  if (parcelGis.propAddr) parts.push(parcelGis.propAddr);
  return parts.join(" · ");
}

export function demoParcelForOwner(owner) {
  if (!isDemoBuild || !owner) return null;
  const tract = String(owner.tract || owner.id || "").replace(/\D/g, "") || "101";
  const pin = `DEMO-${tract}`;
  const parcel = {
    pin,
    propAddr: owner.address,
    acreage: 2.5 + (Number(tract) % 7),
    ownerName: owner.name1,
    centroid: { lat: 35.248 + Number(tract) * 0.0003, lng: -83.696 - Number(tract) * 0.0002 },
    dataSource: "Demo parcel data",
    syncedAt: new Date().toISOString(),
  };
  parcel.mapLinks = {
    ...resolveAssessorLinks(parcel),
    downloads: MACON_PARCEL_GIS.downloadsUrl,
    arcgisFeature: null,
    centroid: parcel.centroid,
  };
  return parcel;
}

export function resolveOwnerParcelGis(owner) {
  if (owner?.parcelGis) return owner.parcelGis;
  return demoParcelForOwner(owner);
}